import React from 'react';
import useQuery from '../../utilities/use-query';
import Redirect from '../redirect';
import searchFilter from '../../utilities/search-filter';
import {useLocation} from 'react-router-dom';
import {useSettingsState} from '../settings';

const INITIAL_SERVICES_LIST = ['64ac0b4576bb3a8b3a183381', '63f0a46d7ce41267297ad280', '65bb93f3e8b9d59b7887479a', '65bb9407e8b9d59b7887479b'];

export const isInitialService = (id) => INITIAL_SERVICES_LIST.includes(id);

const REDIRECT_SERVICE_STRATEGY = {
    '63f0a46d7ce41267297ad280': {
        newId: '684ec217fb81b553c0bbace0'
    },
    '65bb93f3e8b9d59b7887479a': {
        newId: '684ec6c7fb81b553c0bbace6'
    },
    '65bb9407e8b9d59b7887479b': {
        newId: '684ec88afb81b553c0bbacf0'
    }
}

const Migration = ({children}) => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const location = useLocation();
    if (REDIRECT_SERVICE_STRATEGY[serviceId]) {
        return <Redirect {...{to: `${location.pathname}${searchFilter(location.search, {serviceId: REDIRECT_SERVICE_STRATEGY[serviceId].newId})}`, replace: true}}/>
    }
    return (
        <>{children}</>
    );
};

export default React.memo(Migration);